// removed by extract-text-webpack-plugin
module.exports = {"pageSection":"EXPIw","gridContainer":"_6s-Lx","borderTop":"BaJb8","darkBackground":"_3wjYB","spaceBottom":"_1Z36o"};